// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__22SXP","col":"Table_col__nirYc","fulfillmentStatus":"Table_fulfillmentStatus__bPfe4","emailCol":"Table_emailCol__2xuI8"};